// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import type { Spacing } from '@iheartjane/reefer';
import { spacing } from '@iheartjane/reefer-emotion';

export const ButtonWrapper = styled.div<{
  gap: Spacing;
  isIpad: boolean;
  marginTop: Spacing;
}>(({ gap, marginTop, isIpad }) => ({
  display: 'flex',
  ...spacing({ mt: marginTop }),
  gap,
  '> button:first-of-type': {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: '50%',
  },
  '> button:last-of-type': {
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: isIpad ? '50%' : '63%',
  },
}));
